import type { EAppId, ICreateConfigurationInfo, IGroupDetail, SettingsData, IUserDetail, EUserSelection, IGraphPickerItem } from "../../../interfaces";
import type { configurationCreationStep } from "../CreateConfigurationDrawer";
import { SelectApplication } from "./SelectApplication/SelectApplication";
import { AssignUsers } from "../../AssignUsers/AssignUsers";
import { ConfirmCreateSettings } from "./ConfirmCreateSettings/ConfirmCreateSettings";
import { SettingsEditor } from "../../SettingsEditor/SettingsEditor";

export interface IDrawerContentContentProps {
    currentDialog: configurationCreationStep;
    settingsInfo: ICreateConfigurationInfo;
    selectedPeople: IGraphPickerItem[];
    usersToBeAdded: IUserDetail[];
    groupsToBeAdded: IGroupDetail[];
    userSelectionValue: EUserSelection;
    onEnabledChange(isEnabled: boolean): void;
    onDescriptionChange(description: string): void;
    onUserSelectionChange(value: string): void;
    onApplicationSelect(application: EAppId): void;
    onPeopleSelect(selectedPeople: IGraphPickerItem[]): void;
    onSettingsInfoChange(settingsInfo: ICreateConfigurationInfo): void;
}

export const DrawerContent = (props: IDrawerContentContentProps) => {
    const { currentDialog, settingsInfo, selectedPeople, usersToBeAdded, groupsToBeAdded, userSelectionValue, onEnabledChange, onDescriptionChange, onSettingsInfoChange, onApplicationSelect, onPeopleSelect, onUserSelectionChange } = props;

    const onApplicationSelected = (application: EAppId): void => {
        onApplicationSelect(application);
    };

    const onSettingsUpdated = (settings: SettingsData): void => {
        if (settingsInfo) {
            onSettingsInfoChange({ ...settingsInfo, settingsData: settings });
        }
    };

    const onUserSelectionChanged = (value: string): void => {
        onUserSelectionChange(value);
    };

    switch (currentDialog) {
        case "application":
            {
                return (<SelectApplication
                    selectedApplication={settingsInfo?.appId as EAppId}
                    onApplicationSelect={onApplicationSelected} />);
            }

        case "settings":
            {
                return (<SettingsEditor 
                    onSettingsUpdate={onSettingsUpdated} 
                    applicationId={settingsInfo?.appId as EAppId}
                    settingsData={settingsInfo?.settingsData} />);
            }

        case "users":
            {
                return (<AssignUsers
                    userSelection={userSelectionValue}
                    userDetails={[]}
                    groupDetails={[]}
                    selectedPeople={selectedPeople}
                    usersToBeAdded={usersToBeAdded}
                    groupsToBeAdded={groupsToBeAdded}
                    onPeopleSelect={onPeopleSelect}
                    onUserSelectionChange={onUserSelectionChanged} />);
            }

        case "finish":
            {
                return (<ConfirmCreateSettings
                    settingsInfo={settingsInfo}
                    usersToBeAdded={usersToBeAdded}
                    groupsToBeAdded={groupsToBeAdded}
                    onEnabledChange={onEnabledChange}
                    onDescriptionChange={onDescriptionChange} />);
            }


        default:
            return (<></>);

    }
};